import { GridAction } from '@eforall/dashboard';
import { AlignedCommitment } from '../aligned-commitments.part';

export function getActions() {

	const actions: GridAction<AlignedCommitment>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View',
			isEnabled: rows => !!rows.length,
			execute: async rows => { console.log(`Action clicked!`, rows) }
		},
	];

	return actions;
}